import { render } from "./footer.vue?vue&type=template&id=2590b42e&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=2590b42e&lang=css"
import "./footer.vue?vue&type=style&index=1&id=2590b42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2590b42e"]])

export default __exports__